
import Summary from '../views/reports/Summary.vue'
import Consumption from '../views/reports/Consumption.vue'
import Item from '../views/reports/Item.vue'
import Category from '../views/reports/Category.vue'
import Employee from '../views/reports/Employee.vue'
import Payment from '../views/reports/Payment.vue'
import Receipts from '../views/reports/Receipts.vue'
import Debts from '../views/reports/Debts.vue'
import Modifier from '../views/reports/Modifier.vue'
import Discounts from '../views/reports/Discounts.vue'
import Taxes from '../views/reports/Taxes.vue'
import ABC from '../views/reports/ABC.vue'
import Shifts from '../views/reports/Shifts.vue'
import Supplier from '../views/reports/Supplier.vue'
import WorkgroupOrders from '../views/reports/WorkgroupOrderReport.vue';
import WorkgroupOrdersEach from '../views/reports/WorkgroupOrderEachReport.vue';
import ReceiptCreate from '../views/reports/ReceiptCreate.vue';
import ReportsSafe from '../views/reports/SafeReport.vue';
import WorkgroupReportByEmployee from '../views/reports/WorkgroupReportByEmployee.vue';
import ReceiptRefund from '../views/reports/ReceiptRefund.vue';
import SupplierView from "@/views/reports/SupplierView";
import MaterialReport from '../views/reports/MaterialReport.vue'

const reports = [
  { path: '/reports/summary', name: 'reports_summary', component: Summary },
  { path: '/reports/consumption', name: 'reports_consumption', component: Consumption },
  { path: '/reports/abc', name: 'reports_abc', component: ABC },
  { path: '/reports/by/item', name: 'reports_by_item', component: Item },
  { path: '/reports/by/category', name: 'reports_by_category', component: Category },
  { path: '/reports/by/supplier', name: 'reports_by_supplier', component: Supplier },
  { path: '/reports/by/employee', name: 'reports_by_employee', component: Employee },
  { path: '/reports/by/payment_type', name: 'reports_by_payment_type', component: Payment },
  { path: '/reports/receipts', name: 'reports_receipts', component: Receipts },
  { path: '/reports/debts', name: 'reports_debts', component: Debts },
  { path: '/reports/by/modifier', name: 'reports_modifier', component: Modifier },
  { path: '/reports/discounts', name: 'reports_discounts', component: Discounts },
  { path: '/reports/taxes', name: 'reports_taxes', component: Taxes },
  { path: '/reports/shifts', name: 'reports_shifts', component: Shifts },
  { path: '/reports/workgroup-orders', name: 'reports_workgroup_orders', component: WorkgroupOrders },
  { path: '/reports/workgroup-orders-each', name: 'reports_workgroup_orders_each', component: WorkgroupOrdersEach },
  { path: '/reports/receipts/create', name: 'receipt_create', component: ReceiptCreate },
  { path: '/reports/safe', name: 'reports_safe', component: ReportsSafe },
  { path: '/reports/workgroup-report-by-employee', name: 'reports_workgroup_report_by_employee', component: WorkgroupReportByEmployee },
  { path: '/reports/receipts/refund', name: 'receipt_refund', component: ReceiptRefund },
  { path: '/reports/by/supplier-view', name: 'supplier-view', component: SupplierView },
  { path: '/material/report', name: 'material_report', component: MaterialReport }
]

export default {
  reports
}


// function lazyLoad(view) {
//   return () => import(`@/views/reports/${view}.vue`)
// }

// const reports = [
//   { path: '/reports/summary', name: 'reports_summary', component: lazyLoad('Summary') },
//   { path: '/reports/consumption', name: 'reports_consumption', component: lazyLoad('Consumption') },
//   { path: '/reports/abc', name: 'reports_abc', component: lazyLoad('ABC') },
//   { path: '/reports/by/item', name: 'reports_by_item', component: lazyLoad('Item') },
//   { path: '/reports/by/category', name: 'reports_by_category', component: lazyLoad('Category') },
//   { path: '/reports/by/supplier', name: 'reports_by_supplier', component: lazyLoad('Supplier') },
//   { path: '/reports/by/employee', name: 'reports_by_employee', component: lazyLoad('Employee') },
//   { path: '/reports/by/payment_type', name: 'reports_by_payment_type', component: lazyLoad('Payment') },
//   { path: '/reports/receipts', name: 'reports_receipts', component: lazyLoad('Receipts') },
//   { path: '/reports/debts', name: 'reports_debts', component: lazyLoad('Debts') },
//   { path: '/reports/by/modifier', name: 'reports_modifier', component: lazyLoad('Modifier') },
//   { path: '/reports/discounts', name: 'reports_discounts', component: lazyLoad('Discounts') },
//   { path: '/reports/taxes', name: 'reports_taxes', component: lazyLoad('Taxes') },
//   { path: '/reports/shifts', name: 'reports_shifts', component: lazyLoad('Shifts') },
//   { path: '/reports/workgroup-orders', name: 'reports_workgroup_orders', component: lazyLoad('WorkgroupOrderReport') },
//   { path: '/reports/workgroup-orders-each', name: 'reports_workgroup_orders_each', component:lazyLoad('WorkgroupOrderEachReport') },
//   { path: '/reports/receipts/create', name: 'receipt_create', component: lazyLoad('ReceiptCreate') },
//   { path: '/reports/safe', name: 'reports_safe', component: lazyLoad('SafeReport') },
//   { path: '/reports/workgroup-report-by-employee', name: 'reports_workgroup_report_by_employee', component: lazyLoad('WorkgroupReportByEmployee') },
//   { path: '/reports/receipts/refund', name: 'receipt_refund', component: lazyLoad('ReceiptRefund') },
//   { path: '/reports/by/supplier-view', name: 'supplier-view', component: lazyLoad('SupplierView') },
//   { path: '/material/report', name: 'material_report', component: lazyLoad('MaterialReport') }
// ]

